function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import { onResize } from '../../../../wdh-foundation/wdh';

var AccordionSpot = /*#__PURE__*/function (_React$Component) {
  _inherits(AccordionSpot, _React$Component);

  var _super = _createSuper(AccordionSpot);

  function AccordionSpot(props) {
    var _this;

    _classCallCheck(this, AccordionSpot);

    _this = _super.call(this, props);
    var expandAll = false;
    var expandedElements = [];

    if (_this.props.settings.expandAllOnLoad) {
      var _this$buildStateForEx = _this.buildStateForExpandAll();

      expandedElements = _this$buildStateForEx.expandedElements;
      expandAll = _this$buildStateForEx.expandAll;
    } else if (props.settings.expandItemOnLoad !== -1) {
      expandedElements = [props.settings.expandItemOnLoad];
    }

    var isDesktop = _this.props.resolveDesktop();

    _this.state = {
      expandedElements: expandedElements,
      expandAll: expandAll,
      isDesktop: isDesktop
    };
    _this.onElementTitleClick = _this.onElementTitleClick.bind(_assertThisInitialized(_this));
    _this.onExpandAllClick = _this.onExpandAllClick.bind(_assertThisInitialized(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AccordionSpot, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      onResize(function () {
        var isDesktop = _this2.props.resolveDesktop();

        _this2.setState({
          isDesktop: isDesktop
        });
      });
    }
  }, {
    key: "onElementTitleClick",
    value: function onElementTitleClick(event, index) {
      event.preventDefault();
      var expandedElements = this.state.expandedElements;
      var expandedIndexForClickedElement = expandedElements.indexOf(index);

      if (expandedIndexForClickedElement !== -1) {
        expandedElements.splice(expandedIndexForClickedElement, 1);
      } else if (this.props.settings.allowMultipleItemsExpanded) {
        expandedElements.push(index);
      } else {
        expandedElements = [index];
      }

      var expandAll = expandedElements.length === 0 ? false : this.state.expandAll;
      expandAll = expandedElements.length === this.props.settings.elements.length ? true : expandAll;
      this.setState({
        expandedElements: expandedElements,
        expandAll: expandAll
      });
    }
  }, {
    key: "onExpandAllClick",
    value: function onExpandAllClick(event) {
      event.preventDefault();
      var _expandedElements$exp = {
        expandedElements: [],
        expandAll: false
      },
          expandedElements = _expandedElements$exp.expandedElements,
          expandAll = _expandedElements$exp.expandAll;

      if (!this.state.expandAll) {
        var _this$buildStateForEx2 = this.buildStateForExpandAll();

        expandedElements = _this$buildStateForEx2.expandedElements;
        expandAll = _this$buildStateForEx2.expandAll;
      }

      this.setState({
        expandedElements: expandedElements,
        expandAll: expandAll
      });
    }
  }, {
    key: "getStyles",
    value: function getStyles() {
      if (!this.state.isDesktop && this.hasValue('mobileBackgroundImage')) {
        return {
          backgroundImage: "url(".concat(this.props.settings.mobileBackgroundImage, ")")
        };
      } else if (this.state.isDesktop && this.hasValue('desktopBackgroundImage')) {
        return {
          backgroundImage: "url(".concat(this.props.settings.desktopBackgroundImage, ")")
        };
      }

      return {};
    }
  }, {
    key: "buildStateForExpandAll",
    value: function buildStateForExpandAll() {
      return {
        expandedElements: this.props.settings.elements.map(function (element, index) {
          return index;
        }),
        expandAll: true
      };
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event, callback) {
      if (event.keyCode === 13) {
        for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          rest[_key - 2] = arguments[_key];
        }

        callback.apply(this, [].concat(rest));
      }
    }
  }, {
    key: "hasValue",
    value: function hasValue(key) {
      var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var lookUpObject = object || this.props.settings;
      return lookUpObject[key] && lookUpObject[key] !== '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "accordion-spot-elements",
        itemScope: true,
        itemType: this.hasValue('microdataenabled') ? 'https://schema.org/FAQPage' : '',
        style: this.getStyles()
      }, this.hasValue('microdataenabled') && this.hasValue('shrinkAllLabel') && /*#__PURE__*/React.createElement("div", {
        className: "accordion-spot-elements__expand-all ".concat(this.state.expandAll ? 'shrink-all' : 'expand-all'),
        onClick: this.onExpandAllClick,
        role: "button",
        onKeyPress: function onKeyPress(event) {
          _this3.handleKeyPress(event, _this3.onExpandAllClick);
        },
        tabIndex: "0"
      }, this.state.expandAll ? this.props.settings.shrinkAllLabel : this.props.settings.expandAllLabel), this.props.settings.elements.map(function (element, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: "accordion-element-".concat(index),
          className: "accordion-spot-element ".concat(_this3.state.expandedElements.indexOf(index) !== -1 ? 'expand' : 'shrink'),
          "data-index": index + 1,
          itemScope: true,
          itemProp: _this3.hasValue('microdataenabled') ? 'mainEntity' : '',
          itemType: _this3.hasValue('microdataenabled') ? 'https://schema.org/Question' : ''
        }, /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__title",
          onClick: function onClick(event) {
            _this3.onElementTitleClick(event, index);
          },
          role: "button",
          onKeyPress: function onKeyPress(event) {
            _this3.onElementTitleClick(event, _this3.onExpandAllClick, index);
          },
          tabIndex: index + 1,
          itemProp: _this3.hasValue('microdataenabled') ? 'name' : ''
        }, element.title), /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__content",
          itemScope: true,
          itemProp: _this3.hasValue('microdataenabled') ? 'acceptedAnswer' : '',
          itemType: _this3.hasValue('microdataenabled') ? 'https://schema.org/Answer' : ''
        }, _this3.hasValue('header', element) && /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__header"
        }, element.header), _this3.hasValue('body', element) && /*#__PURE__*/React.createElement("div", {
          className: "accordion-spot-element__body",
          itemProp: _this3.hasValue('microdataenabled') ? 'text' : '',
          dangerouslySetInnerHTML: {
            __html: element.body
          }
        })));
      }));
    }
  }]);

  return AccordionSpot;
}(React.Component);

AccordionSpot.propTypes = {
  settings: PropTypes.shape({
    mobileBackgroundImage: PropTypes.string,
    desktopBackgroundImage: PropTypes.string,
    expandAllLabel: PropTypes.string,
    shrinkAllLabel: PropTypes.string,
    allowMultipleItemsExpanded: PropTypes.bool,
    expandItemOnLoad: PropTypes.number,
    expandAllOnLoad: PropTypes.bool,
    elements: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      header: PropTypes.string,
      body: PropTypes.string
    }))
  }),
  resolveDesktop: PropTypes.func.isRequired
};
AccordionSpot.defaultProps = {
  settings: {
    mobileBackgroundImage: '',
    desktopBbackgroundImage: '',
    expandAllLabel: '',
    shrinkAllLabel: '',
    allowMultipleItemsExpanded: false,
    expandItemOnLoad: 0,
    expandAllOnLoad: false,
    elements: []
  }
};
export default AccordionSpot;